import React from 'react';
import SelectEntityFactory from '../Common/SelectEntityFactory';
import ModuleActions from '../../actions/ModuleActionCreator';
import { SearchTypes } from '../../constants/CentricConstants';

export default SelectEntityFactory(ModuleActions.search, {searchType: SearchTypes.MODULES});
